<template>
    <div>
        <div v-if="!isReady" class="text-xs-center">
            <v-progress-circular indeterminate color="primary" />
        </div>
        <GChart
            type="ColumnChart"
            :settings="{ packages: ['corechart'], language: $i18n.locale }"
            :data="data"
            :options="chartOptions"
            :events="chartEvents"
            @ready="onChartReady"
        />
    </div>
</template>

<script>
import { merge } from 'lodash';
import { GChart } from 'vue-google-charts';
import chartTooltipPositionMixin from '@/mixins/chartTooltipPositionMixin';
import exportService from '../../../services/exportService';
import chartActionResetMixin from '../../../mixins/chartActionResetMixin';
import chartActionSelectDateMixin from '../../../mixins/chartActionSelectDateMixin';

export default {
    name: 'column-chart-graph',
    mixins: [
        chartActionResetMixin,
        chartActionSelectDateMixin,
        chartTooltipPositionMixin,
    ],
    components: {
        GChart,
    },
    props: {
        data: {
            type: Array,
            required: true,
        },
        options: {
            type: Object,
            default: () => ({}),
        },
        events: {
            type: Object,
            default: () => ({}),
        },
        expanded: {
            type: Boolean,
            default: false,
        },
        styleTextNode: {
            type: Function,
        },
    },
    data() {
        return {
            baseOptions: {
                legend: {
                    position: 'top',
                    maxLines: 3,
                },
                hAxis: {
                    slantedText: true,
                },
                vAxes: {
                    0: {
                        title: '',
                        format: 'short',
                    },
                },
                chartArea: {
                    top: 35,
                    left: 75,
                    right: 50,
                    width: '90%',
                    height: '65%',
                },
                colors: [this.$vuetify.theme.primary],
                backgroundColor: '#f5f5f5',
                selectionMode: 'multiple',
                tooltip: {
                    trigger: 'selection',
                    isHtml: true,
                },
            },
            baseEvents: {
                ready: () => {
                    this.isReady = true;
                    this.addChartActionReset();
                    this.addChartActionSelectDate();
                    this.addChartTooltipPosition();
                    this.setXAxisLabelStyle();
                },
                select: () => {
                    this.addChartActionSelectDate();
                },
            },
            isReady: false,
            chart: null,
            google: null,
        };
    },
    computed: {
        chartOptions() {
            const baseHeight = this.options.height ? this.options.height : 300;
            const height = this.expanded ? window.outerHeight - 60 : baseHeight;
            return merge(this.baseOptions, this.options, { height });
        },
        chartEvents() {
            return merge(this.baseEvents, this.events);
        },
    },
    methods: {
        onChartReady(chart, google) {
            this.chart = chart;
            this.google = google;
        },
        setXAxisLabelStyle() {
            if (typeof this.styleTextNode === 'function') {
                const nodes = this.chart.container.querySelectorAll('text');
                nodes.forEach(node => this.styleTextNode(node));
            }
        },
        exportData(title = 'export') {
            exportService.exportDataImage(this.chart.getImageURI(), title);
        },
    },
};
</script>

<style lang="scss" scoped>
</style>
